import { useEffect, useState } from 'react';
import './ChangeGameType.scoped.scss';
import { getRecoil } from 'recoil-nexus';
import { projectTypesState } from '../../../atoms/service';
import emitChangeNormalRoomGameType from '../../../connector/emits/changeNormalRoomGameType';
import roomDetailState from '../../../atoms/roomDetail';

const ChangeGameType = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const roomDetail = getRecoil(roomDetailState);
  const projectTypes = getRecoil(projectTypesState);

  const [selectedProjectType, setSelectedProjectType] = useState('');

  useEffect(() => {
    setSelectedProjectType(projectTypes[0]);
  }, [projectTypes]);

  const saveChangeGameType = () => {
    emitChangeNormalRoomGameType(roomDetail.id, selectedProjectType);
  };

  return (
    <div className="change-game-type">
      <div className="change-game-type__left">
        <div className="change-game-type__row">
          <div className="change-game-type__row__title">게임타입</div>
          <select
            className="change-game-type__change-game-type-select"
            value={selectedProjectType}
            onChange={(e) => setSelectedProjectType(e.target.value)}
          >
            {projectTypes.map((projectType, i) => (
              <option value={projectType} key={i}>{projectType}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="change-game-type__right">
        <button onClick={saveChangeGameType}>게임 타입 변경</button>
      </div>
    </div>
  );
};

export default ChangeGameType;
